import images from "@assets/images";
import { useNavigation } from "@react-navigation/native";
import { ImageButton06 } from "components/button";
import React from "react";
import { View } from "react-native";
import { runOnJS, SharedValue, useAnimatedReaction } from "react-native-reanimated";
import { useFetchPost } from "utils/api/hooks";
import useStyles from "./styles.css";

type Props = {
  onCancel: () => void;
  animatedValue: SharedValue<number>;
}

const ItemShop = (props: Props) => {
  const styles = useStyles();
  const { loading } = useFetchPost();
  const navigation = useNavigation<any>();
  const [enabled, setEnabled] = React.useState(false);

  const handlePress = () => {
    if(enabled){
      navigation.navigate("gold-conversion");
      props.onCancel();
    }
  };

  useAnimatedReaction(
    () => props.animatedValue.value,
    (value, previousValue) => {
      if (value !== previousValue) {
        runOnJS(setEnabled)(value === 1);
      }
    }
  );

  return (
    <View style={styles.v_container_shop}>
      <ImageButton06 
        scaleSize={1}
        onPress={handlePress} 
        isLoading={loading}
        disabled={!enabled}
        style={styles.v_item_shop}
        source={{uri: images["btn-convert"]}}
      />
    </View>
  );
};

export default ItemShop;
